import React from 'react';
import { HubspotBanner } from './HubspotBanner';

export const SignupBanner = (): JSX.Element => {
  const pageName = 'auth-signup';

  return <HubspotBanner pageName={pageName} />;
};
